<template>
  <div>
    <v-autocomplete
      v-model="value.responsiblePerson"
      :items="userDataMap"
      :loading="getAllUsersStatus"
      hide-no-data
      clearable
      item-text="Description"
      item-value="id"
      :label="$t('inspections.responsiblePerson')"
      data-cy="responsiblePerson"
      dense
    >
    </v-autocomplete>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: ["value", "config"],
  mounted() {
    this.$store.dispatch("getUsers");
  },
  computed: {
    ...mapGetters(["getAllUsers", "getAllUsersStatus"]),
    userDataMap() {
      return this.getAllUsers.map((user) => {
        const Description = user.name + " - " + user.short;
        const id = user._id;
        return Object.assign({}, user, {
          Description,
          id,
        });
      });
    },
  },
};
</script>
